module.exports = __webpack_public_path__ + "static/images/containers/WGCWXLeaderboards/images/background_vehicles_dark.290d1499.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXLeaderboards/images/background_vehicles_dark.jpg
// module id = 3477
// module chunks = 11